module.exports = __webpack_public_path__ + "img/fancy.43845c7.jpg";